import type { FunctionComponent } from 'react';
import React from 'react';
import Routes from './Routes';
import { BrowserRouter } from 'react-router-dom';
import { registerLocale } from 'react-datepicker';
import { I18nProvider } from '@whizz/react-i18n';
import { MixpanelProvider } from 'react-mixpanel-browser';
import { model } from '@whizz/api-client';
import * as luxon from 'luxon';
import IdentityProviderWrapper from './IdentityProviderWrapper';
import LogApiErrors from './LogApiErrors';
import translations from '../translations';
import ErrorBoundaryWrapper from './ErrorBoundaryWrapper';
import * as queryString from 'querystring';
import LocaleNotFound from '../pages/LocaleNotFound';
import { LiveChat } from '../pages/Home/modules';
// Locales from date-fns - These are needed for datepicker component
import enGB from 'date-fns/locale/en-GB';
import enUS from 'date-fns/locale/en-US';
import thTH from 'date-fns/locale/th';
import { AppContextProvider } from '../context/AppContextProvider';
import Nudges from '../components/nudges/Nudges';

export const DEFAULT_LOCALE_ID = 'en-gb';
export const STORAGE_NAME_LOCALE = 'tx3_locale';

const supportedLocale = Object.keys(translations);
const queryLocale = (queryString.parse(window.location.search).locale as string) || window.sessionStorage.getItem(STORAGE_NAME_LOCALE) || undefined;
if (queryLocale) {
  window.sessionStorage.setItem(STORAGE_NAME_LOCALE, queryLocale);
}

const locale = new model.Locale(
  {
    id: (queryLocale && supportedLocale.includes(queryLocale)) ? queryLocale : DEFAULT_LOCALE_ID,
  },
);

const App: FunctionComponent = () => {
  if (!Object.keys(translations).includes(locale.getId())) {
    return <LocaleNotFound />;
  }

  // Register locales for datepicker component
  registerLocale('en-gb', enGB);
  registerLocale('en-us', enUS);
  registerLocale('th-th', thTH);

  return (
    <I18nProvider locale={locale} loadingComponent={<></>} translations={translations} luxon={luxon}>
      <ErrorBoundaryWrapper>
        <MixpanelProvider config={{ secure_cookie: true }}>
          <IdentityProviderWrapper>
            <LogApiErrors>
              <BrowserRouter>
                <AppContextProvider>
                  <Routes />
                </AppContextProvider>
              </BrowserRouter>
              <Nudges />
              <LiveChat />
            </LogApiErrors>
          </IdentityProviderWrapper>
        </MixpanelProvider>
      </ErrorBoundaryWrapper>
    </I18nProvider>
  );
};

export default App;
